import CommunicationHistory from '../components/CommunicationHistory';
import CallInteractions from '../components/CommunicationHistory/CallInteractions';
import SystemInteractions from '../components/CommunicationHistory/SystemInteractions';
import EmiSchedule from '../components/EmiSchedule';
import Interactions from '../components/Interactions';
import Overview from '../components/Overview';
import RepaymentTab from '../components/Repayment';
import PhoneNumberDetails from '../components/PhoneNumber';
import { SYSTEM_INTERACTIONS_TYPE } from './communicationHistory.constant';
import PreviousLoanCommunicationHistory from '../components/PreviousLoanCommunicationHistory/PreviousLoanCommunicationHistory';
import { ECallingType } from '../feedbackForm/interfaces/index.type';
import Geolocations from '../components/Addresses/GeolocationsTab';
import Contact from '../components/Contact';
import SkipTracing from '../components/SkipTracing';
import AllDocumentsV2 from '@cp/pages/CaseDetails/components/AllDocumentsV2';
import Escalations from '../components/Escalations';
import TopAddresses from '../components/TopAddresses';
import AddressesTab from '../components/Addresses/AddressesTab';
import FieldCallInteractions from '../components/CommunicationHistory/FieldCallInteractions';

export const TAB_KEYS = {
  OVERVIEW: 'overview',
  EMI_SCHEDULE: 'emi_schedule',
  MORE_DETAILS: 'more_details',
  COMMUNICATION_HISTORY: 'communication_history',
  DOCUMENTS: 'documents',
  REPAYMENT_HISTORY: 'repayment_history',
  CONTACT: 'contact',
  ADDRESSES: 'addresses',
  PREV_LOAN_INTERACTIONS: 'prev_loan_interactions',
  SKIP_TRACING: 'skip_tracing'
};

export const ToastMessage = {
  ENACH_LINK_SHARED_SUCESSFULLY: 'Link shared successfully',
  NUMBER_ADDED_SUCCESSFULLY: 'Number added successfully',
  MOBILE_NUMBER_FORMAT: 'Mobile Number would be numberic and of 10 digits',
  NUMBER_ADDITION_FAILED: 'Number addition failed',
  EMAIL_ADDED_SUCCESSFULLY: 'Email added successfully',
  EMAIL_ADDITION_FAILED: 'Email addition failed',
  EMAIL_FORMAT: 'Please enter valid email address'
};

export enum VALIDATION_MESSAGE {
  ADDRESS_LENGTH_VALIDATION_MESSAGE = 'Please enter at least 5 characters (a-z & 0-9)',
  ADDRESS_VALIDATION_MESSAGE = 'Please enter a valid address',
  PINCODE_VALIDATION_MESSAGE = 'Please enter a valid pincode'
}

export const CASE_DETAILS_TABS_FEATURE_FLAG = {
  SKIP_TRACING: 'skipTracing'
} as const;

type Tabs = {
  key: string;
  value: string;
  component: React.ReactNode;
  isNew?: boolean;
  featureFlagKey?: string;
};

export const TabsTORemove = {
  [TAB_KEYS.ADDRESSES]: true,
  [TAB_KEYS.SKIP_TRACING]: true
};

export const TABS: Tabs[] = [
  {
    key: TAB_KEYS.OVERVIEW,
    value: 'Overview',
    component: <Overview />
  },
  {
    key: TAB_KEYS.EMI_SCHEDULE,
    value: 'EMI schedule',
    component: <EmiSchedule />
  },
  {
    key: TAB_KEYS.REPAYMENT_HISTORY,
    value: 'Repayment',
    component: <RepaymentTab />
  },
  {
    key: TAB_KEYS.ADDRESSES,
    value: 'Addresses',
    component: <TopAddresses />
  },
  {
    key: TAB_KEYS.CONTACT,
    value: 'Contact',
    component: <Contact />
  },
  {
    key: TAB_KEYS.DOCUMENTS,
    value: 'Documents',
    component: <AllDocumentsV2 />
  },
  {
    key: TAB_KEYS.COMMUNICATION_HISTORY,
    value: 'Interactions',
    component: <CommunicationHistory />
  },
  {
    key: TAB_KEYS.PREV_LOAN_INTERACTIONS,
    value: 'Prev loans interactions',
    component: <PreviousLoanCommunicationHistory />
  },
  {
    key: TAB_KEYS.SKIP_TRACING,
    value: 'Customer Outreach',
    component: <SkipTracing />,
    featureFlagKey: CASE_DETAILS_TABS_FEATURE_FLAG.SKIP_TRACING
  }
];

export const COMMUNICATION_TAB_KEYS = {
  CALLS: 'calls',
  WHATSAPP: 'whatsapp',
  FIELD_VISIT: 'FIELD_VISIT',
  SMS: 'sms',
  IVR: 'ivr',
  EMAIL: 'email',
  PUSH_NOTIFICATION: 'push_notification',
  NAVI_WHATSAPP: 'navi_whatsapp',
  ESCALATIONS: 'escalations',
  FIELD_CALLING: 'FIELD_CALLING'
};

export const COMMUNICATION_TABS = [
  {
    key: COMMUNICATION_TAB_KEYS.CALLS,
    value: 'Feedbacks',
    component: <CallInteractions />
  },
  {
    key: COMMUNICATION_TAB_KEYS.FIELD_VISIT,
    value: 'Field',
    component: <SystemInteractions type={SYSTEM_INTERACTIONS_TYPE.FIELD_VISIT} />
  },
  {
    key: COMMUNICATION_TAB_KEYS.FIELD_CALLING,
    value: 'Field Calls',
    component: <FieldCallInteractions />
  },
  {
    key: COMMUNICATION_TAB_KEYS.NAVI_WHATSAPP,
    value: 'Navi WA',
    component: <Interactions />
  },
  {
    key: COMMUNICATION_TAB_KEYS.SMS,
    value: 'SMS',
    component: <SystemInteractions type={SYSTEM_INTERACTIONS_TYPE.SMS} />
  },
  {
    key: COMMUNICATION_TAB_KEYS.WHATSAPP,
    value: 'Whatsapp',
    component: <SystemInteractions type={SYSTEM_INTERACTIONS_TYPE.WHATSAPP} />
  },
  // {
  //   key: COMMUNICATION_TAB_KEYS.IVR,
  //   value: 'IVR',
  //   component: <SystemInteractions type={SYSTEM_INTERACTIONS_TYPE.IVR} />
  // },
  {
    key: COMMUNICATION_TAB_KEYS.PUSH_NOTIFICATION,
    value: 'Notification',
    component: <SystemInteractions type={SYSTEM_INTERACTIONS_TYPE.PUSH_NOTIFICATION} />
  },
  {
    key: COMMUNICATION_TAB_KEYS.EMAIL,
    value: 'Email',
    component: <SystemInteractions type={SYSTEM_INTERACTIONS_TYPE.EMAIL} />
  },
  {
    key: COMMUNICATION_TAB_KEYS.ESCALATIONS,
    value: 'Escalations',
    component: <Escalations />
  }
];
export enum CUSTOMER_TAGS {
  RBI = 'RBI',
  LEGAL = 'LEGAL',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  GENERAL_GRIEVANCE = 'GENERAL_GRIEVANCE',
  FRAUD = 'FRAUD'
}

export enum CONTACT_TYPES {
  SKIP_TRACE = 'SKIP_TRACE',
  SPADE = 'SPADE'
}

export enum CONTACT_BUCKET {
  CONNECTED_CLOSE_CONTACT = 'CONNECTED_CLOSE_CONTACT',
  NOT_CONNECTED_CLOSE_CONTACT = 'NOT_CONNECTED_CLOSE_CONTACT',
  THIRD_PARTY_CONTACT = 'THIRD_PARTY_CONTACT',
  OTHERS = 'OTHERS'
}

export const CUSTOMER_TAGS_READABLE: Record<string, string> = {
  [CUSTOMER_TAGS.RBI]: 'RBI',
  [CUSTOMER_TAGS.LEGAL]: 'Legal',
  [CUSTOMER_TAGS.SOCIAL_MEDIA]: 'Social Media',
  [CUSTOMER_TAGS.GENERAL_GRIEVANCE]: 'General Grievance',
  [CUSTOMER_TAGS.FRAUD]: 'Fraud'
};

export enum STORE_KEYS {
  TOP_ADDRESSES = 'topAddresses',
  DETAILS = 'details',
  REPAYMENT_HISTORY = 'repaymentHistory',
  TELEPHONES = 'telephones',
  SKIP_TRACING_DATA = 'skipTracingData',
  SPADE_DATA = 'spadeData',
  ENACH = 'enach',
  FEEDBACK_HISTORY = 'feedbackHistory',
  ADDRESSES = 'addresses',
  PENDING_FEE_COMPONENTS = 'pendingFeeComponents',
  FEE_COMPONENT_ADJUSTMENTS = 'feeComponentAdjustments',
  EMI_BREAKUP = 'emiBreakup',
  REPAYMENT_DUE = 'repaymentDue',
  MONTHLY_ENACH = 'monthlyEnach',
  WA_INTERACTIONS = 'waInteractions',
  ESCALATIONS = 'escalations',
  CALL_INTERACTIONS = 'callInteractions',
  FIELD_CALL_INTERACTIONS = 'fieldCallInteractions',
  CUSTOMER_DOCS = 'customerDocs',
  LEGAL_DOCS = 'legalDocs',
  CUSTOMER_INFO = 'customerInfo',
  REPAYMENTS_HISTORY = 'repaymentsHistory',
  TELEPHONES_V2 = 'telephonesv2',
  SHERLOCK = 'sherlock',
  EMAILS = 'emails',
  GEOLOCATIONS_ADDRESSES = 'geolocationsAndAddresses',
  SIMILAR_GEOLOCATIONS = 'similarGeolocations',
  SECONDARY_SOURCES = 'secondarySources',
  PAUSE_STATUS = 'pause'
}

const COSMOS_PATH = '/cosmos';
export const ExcludedRedirectionEndPointsList = [COSMOS_PATH];

export const REVAMPED_CALLING_TYPES = [
  {
    value: ECallingType.AMEYO,
    label: 'Ameyo',
    isHiddenForExternal: true
  },
  {
    value: ECallingType.SLASH,
    label: 'Slash'
  },
  {
    value: ECallingType.SELF_CALL,
    label: 'Self call',
    isHiddenForExternal: true
  },
  {
    value: ECallingType.WHATSAPP_TEXT,
    label: 'Whatsapp Text',
    isHiddenForExternal: true
  },
  {
    value: ECallingType.SKIP_TRACING,
    label: 'Customer Outreach',
    isHiddenForExternal: true
  },
  {
    value: ECallingType.VENDOR_POC,
    label: 'Vendor POC'
  }
];

export const OLD_CALLING_TYPES = [
  {
    value: ECallingType.AMEYO,
    label: 'Ameyo',
    isHiddenForExternal: true
  },
  {
    value: ECallingType.SLASH,
    label: 'Slash'
  },
  {
    value: ECallingType.SELF_CALL,
    label: 'Self call',
    isHiddenForExternal: true
  }
];

export const ADDRESSES_TAB_KEYS = {
  ADDRESSES: 'addresses',
  GEOLOCATIONS: 'geolocations'
};

export const ADDRESSES_TAB = [
  {
    key: TAB_KEYS.ADDRESSES,
    value: 'Addresses',
    component: <AddressesTab />
  },
  {
    key: ADDRESSES_TAB_KEYS.GEOLOCATIONS,
    value: 'VKYC Location',
    component: <Geolocations />
  }
];

export const defaultQueryParamsAddressTab = {
  addresses: {
    selectedTab: TAB_KEYS.ADDRESSES
  }
};
export const CURRENT_PAGE = 'addresses';

export const CONTACT_TABS = {
  PHONE_NUMBER: 'phone_number',
  EMAIL_IDS: 'email_ids'
};
export const CONTACT_TABS_KEYS = [
  {
    key: CONTACT_TABS.PHONE_NUMBER,
    value: 'Phone Numbers',
    component: <PhoneNumberDetails />
  }
  // {
  //   key: CONTACT_TABS.EMAIL_IDS,
  //   value: 'Email IDs',
  //   component: <EmailIds />
  // }
];

export const defaultQueryParams = {
  contacts: {
    selectedTab: CONTACT_TABS.PHONE_NUMBER
  }
};

export const UI_ELEMENT = 'contacts';
export const TERMINAL_INTERACTION_SORT_ORDER = 'TERMINAL_INTERACTION_SORT_ORDER';
